"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridTripletsView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@obvio/utils");
function GridTripletsView({ elements, renderOne, renderTwo, renderThree, }) {
    const chunks = (0, utils_1.chunkify)(elements, 3);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: chunks.map((chunk, index) => {
            const odd = index % 2 === 0;
            switch (chunk.length) {
                case 1: {
                    return renderOne(chunk[0], odd);
                }
                case 2: {
                    return renderTwo(chunk, odd);
                }
                default: {
                    return renderThree(chunk, odd);
                }
            }
        }) }));
}
exports.GridTripletsView = GridTripletsView;
